module.exports = __webpack_public_path__ + "img/receipt.995b328f.svg";